import { FC } from 'react';
import { ActivityInput, Domain } from '../../../graphql/generated/graphql.ts';
import { Card, CardContent, Divider, List, ListItemButton, Stack, Typography } from '@mui/material';
import { DomainListItem } from '../../../components/domain/domain-list-item.tsx';
import { useGetSuggestionsQuery } from '../../../graphql/generated/operations/suggestion.ts';
import { LoadingBackdrop } from '../../../components/loading.backdrop.tsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Form, Formik } from 'formik';
import { TextInput } from '../../../components/forms/text-input.tsx';
import { SubmitButton } from '../../../components/forms/submit.button.tsx';
import * as yup from 'yup';

export interface ActivitySuggestionsProps {
  input: Partial<ActivityInput>;
  domain: Partial<Domain>;
  onNext: (input: Partial<ActivityInput>) => void;
}

const customActivityValidationSchema = yup.object().shape({
  description: yup.string().required('Description is required')
});

export const ActivitySuggestions: FC<ActivitySuggestionsProps> = ({ domain, input, onNext }) => {
  const { data, loading } = useGetSuggestionsQuery({
    variables: { domainId: input.domainID || '' },
    skip: !input.domainID
  });

  if (loading) {
    return <LoadingBackdrop />;
  }

  return (
    <Stack>
      <DomainListItem domain={domain} />
      <Typography variant="h4" sx={{ my: 2 }}>
        Create your own Activity
      </Typography>
      <Card>
        <CardContent>
          <Formik
            validationSchema={customActivityValidationSchema}
            initialValues={{
              description: ''
            }}
            onSubmit={(values) => {
              onNext({
                ...input,
                description: values.description
              });
            }}
          >
            <Form>
              <Stack>
                <Typography variant="h6">Description</Typography>
                <TextInput name="description" />
                <SubmitButton>Create Activity</SubmitButton>
              </Stack>
            </Form>
          </Formik>
        </CardContent>
      </Card>
      {data?.suggestions && data.suggestions.length > 0 && (
        <>
          <Divider sx={{ my: 2 }}>
            <Typography variant="h6">Or</Typography>
          </Divider>
          <Typography variant="h4" gutterBottom>
            Choose an Activity
          </Typography>
          <List>
            <Divider />
            {data?.suggestions.map((suggestion) => (
              <>
                <ListItemButton
                  key={suggestion._id}
                  onClick={() => {
                    onNext({
                      ...input,
                      description: suggestion.description
                    });
                  }}
                >
                  <Typography variant="h6">{suggestion.description}</Typography>
                  <FontAwesomeIcon icon={faChevronRight} style={{ marginLeft: 'auto' }} />
                </ListItemButton>
                <Divider />
              </>
            ))}
          </List>
        </>
      )}
    </Stack>
  );
};
